// extracted by mini-css-extract-plugin
module.exports = {"contact":"style-module--contact--oDeqy","h4":"style-module--h4--6HhYT"};